export default __webpack_public_path__ + "static/media/unpaid-icon.575d93fe.svg";